import React from 'react';
import { t } from 'i18next';
import { ModalContainer } from 'src/components/Modals/components';
import MvpAppBody from 'src/components/Modals/components/MvpAppBody';

interface Props {
  title?: string;
  footer?: React.ReactElement;
  onConfirm?: () => void;
  onCancel?: () => void;
}

const MvpAppRejectModalMessage = ({
  onCancel,
  onConfirm,
  footer,
  title = t('Confirmation'),
}: Props) => {
  const message: string = t(
    'IfYouRejectTheAgreementItWillBeDiscardedAndStoredInTheArchive'
  );
  const contentMessage: string = t('AreYouSureYouWantToRejectTheAgreement');

  return (
    <ModalContainer width={320}>
      <MvpAppBody
        onConfirm={onConfirm}
        onCancel={onCancel}
        title={title}
        footer={footer}
        message={message}
        contentMessage={contentMessage}
        isSuccessDialog={false}
      />
    </ModalContainer>
  );
};

export default MvpAppRejectModalMessage;
